import { ContainerStatusEnum, ErrorResponse, GlobalStatus, InvoiceStatusEnum } from '@gtpl/shared-models/common-models';
import { FileUploadResponse, PlantInvoiceCreateResponse } from '@gtpl/shared-models/logistics';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PlantInvoiceAdapter } from './adapters/plant-invoice.adapter';
import { SoCustomerInvoice } from './customer-invoice.entity';
import { PlantInvoiceDto } from './dto/plant-invoice.dto';
import { CustomerInvoiceRepository } from './repository/customer-invoice-repository';
import { SoInvoiceRepository } from './repository/so-inv-details-repository';
import { SoItemRepository } from './repository/so-items-repository';
import { SoRepository } from './repository/so-repository';
import { SaleOrderItems } from './sale-order-items.entity';
import appSettings from 'apps/services/config';
import { CompanyTypeEnum } from '@gtpl/shared-models/masters';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { SaleOrderDto } from './dto/sale-order.dto';
import { Connection, Repository, getManager } from 'typeorm';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { InjectRepository } from '@nestjs/typeorm';
import moment from 'moment';
import { SaleOrder } from './sale-order.entitiy';
import { SaleOrderTrack } from './so-track.entity';


@Injectable()
export class CustomerInvoiceService {
    constructor(private csInvoiceRepo:CustomerInvoiceRepository, private soInvItemRepo:SoItemRepository,private adapter:PlantInvoiceAdapter, private soRepo:SoRepository, private unitcodeService: UnitcodeService,
      private readonly connection: Connection,
    ){}
    

    // async createPlantInvoice(invoiceDto: PlantInvoiceDto, isUpdate:boolean):Promise<PlantInvoiceCreateResponse>{
    //     console.log("Invoice Service")
    //     const manager = new GenericTransactionManager();
    //     try{
    //         let today =new Date();
    //         let CurrentYear = today.getFullYear();
    //         let CurrentMonth = today.getMonth();
    //         let fromDate=0;
    //         let toDate=0;
    //         let count;
    //         count = await this.csInvoiceRepo.count();
    //         count = count + 1;
    //         if(!isUpdate){
    //             if (CurrentMonth<4) {
    //                 fromDate=(CurrentYear);
    //                 toDate=(CurrentYear+1);
    //             } else {
    //                 fromDate=(CurrentYear);
    //                 toDate=(CurrentYear+1);
    //             }
    //             const customerInvEntity = await this.getDuplicateInvoice(invoiceDto.saleOrderId);
    //             if (customerInvEntity) {
    //                 return new PlantInvoiceCreateResponse(false,11104, 'Already Invoiced');
    //               }
    //         }
         
    //         const currentFinancialYear = "INV/"+(fromDate)+"-"+(toDate)+"/"+count;
    //         console.log(invoiceDto);
    //         console.log('Service');
    //         // convert entity to dto
    //         const convertedEntity = await this.adapter.convertDtoToEntity(invoiceDto, currentFinancialYear);
    //         console.log(convertedEntity);
    //         await manager.startTransaction();

    //         // save the converted Entity
    //         const savedEntity = await manager.getCustomRepository(CustomerInvoiceRepository).save(convertedEntity);
    //         if(savedEntity){
    //                 for(const invoiceItems of invoiceDto.invoiceItemsInfo){
    //                     const csInvItem = new SaleOrderItems();
    //                     csInvItem.saleOrderItemId = invoiceItems.saleOrderItemId;
    //                     csInvItem.revisedUnitPrice = invoiceItems.revisedUnitPrice;
    //                     csInvItem.invoicedQty = invoiceItems.invoicedQuantity;
    //                     csInvItem.invoicedCases = invoiceItems.invoicedCases;
    //                     csInvItem.invoiceAmount = invoiceItems.invoiceAmount;
    //                     csInvItem.grossWeightPerKg = invoiceItems.grossWeight;
    //                     //for temperory dispatched qty given.need to remove after completion of warehouse as dispatched qty updated from warehouse
    //                     //csInvItem.dispatchedQty = invoiceItems.dispatchedQty;
    //                     csInvItem.totalGrossWeight = invoiceItems.grossWeight * invoiceItems.invoicedCases
    //                     console.log('*******revisedUnitPrice ',csInvItem.revisedUnitPrice)
    //                     csInvItem.taxId = invoiceItems.taxId;
    //                     const updateInvItem = await manager.getCustomRepository(SoItemRepository).save(csInvItem);
    //                 }
    //                 const updateSo = await manager.getCustomRepository(SoRepository).update({saleOrderId:invoiceDto.saleOrderId},{
    //                     isInvoiced:GlobalStatus.YES
    //                 });
    //                 const updateInvDetails = await manager.getCustomRepository(SoInvoiceRepository).update({saleOrderId:invoiceDto.saleOrderId},{
    //                     payTermId:invoiceDto.paymentTerms,destination:invoiceDto.finalDestination,portOfEntry:invoiceDto.portOfLoading,edaDate:invoiceDto.etaDate
    //                 });

    //                 if(updateSo.affected&&updateInvDetails.affected&&!isUpdate){
    //                     await manager.completeTransaction();
    //                 }else{
    //                     if(isUpdate){
    //                         await manager.completeTransaction();
    //                     }else{
    //                         throw new ErrorResponse(9999, 'Failed To Update Sale Order');
    //                     }
    //                 }
    //                 return new PlantInvoiceCreateResponse(true, 1111, 'Invoice Created Successfully');
    //         }else{
    //             throw new ErrorResponse(9999, 'Something Went Wrong');
    //         }

    //     }catch(err){
    //         await manager.releaseTransaction();
    //         console.log(err);
    //         return err;
    //     }
    // }


    async createPlantInvoice( invoiceDto: PlantInvoiceDto, isUpdate: boolean): Promise<PlantInvoiceCreateResponse> {
        const manager = new GenericTransactionManager();
        try {
            let today = moment(invoiceDto.invoiceDate);

            let CurrentYear = today.year();
            let CurrentMonth = Number(today.format('MM'));
            let fromDate = 0;
            let toDate = 0;
            let count;
            let refNum;
            let company = '';
            let finToDate = 0;
            let finFromDate = 0;
            
            let query;
            const plant = await this.unitcodeService.getPlantDetailsById({ unitcodeId: invoiceDto.exporterId }) 
            console.log(invoiceDto.unitId ,'plantttttttttttttt');
            if (CurrentMonth < 4) {
                finFromDate = (CurrentYear - 1);
                finToDate = (CurrentYear);
            } else {
                finFromDate = (CurrentYear);
                finToDate = (CurrentYear + 1);
            }

            const financialYear= (finFromDate.toString().substr(-2)) +'-'+ (finToDate.toString().substr(-2))

              
            const createdAt = moment(); 

            let cycleStart: moment.Moment;
            let cycleEnd: moment.Moment;

            if (createdAt.month() + 1 >= 4) {
                
                cycleStart = moment(`${createdAt.year()}-04-01`);
                cycleEnd = moment(`${createdAt.year() + 1}-03-31`).endOf('day');
            } else {
                
                cycleStart = moment(`${createdAt.year() - 1}-04-01`);
                cycleEnd = moment(`${createdAt.year()}-03-31`).endOf('day');
            }
            let companyPrefix = '';

// if (plant.data?.company === CompanyTypeEnum.SPSA_SILKS_PVT_LTD) {
    companyPrefix = 'SPSA';
// } else if (plant.data?.company === CompanyTypeEnum.BMR_EXPORTS_ODISHA) {
//     companyPrefix = 'BMROD';
// } else if (plant.data?.company === CompanyTypeEnum.BMR_EXPORTS_AP) {
//     companyPrefix = 'BMR';
// }
console.log(companyPrefix,'companyPrefixcompanyPrefixcompanyPrefixcompanyPrefix')
      query = `
SELECT MAX(ref_no) AS refNumber
FROM ${appSettings.sales_db}.customer_invoice ci
WHERE ci.exporter_id = '${invoiceDto.exporterId}'
  AND ci.invoice_number LIKE '${companyPrefix}-%'
  AND ci.financial_year = '${financialYear}'
`;

if (!companyPrefix) {
    throw new ErrorResponse(
        400,
        `Invoice prefix not configured for company: ${plant.data?.company}`
    );
}


            // if (createdMonth >= 4) {
            //     query = `SELECT MAX(ref_no) as refNumber FROM ${appSettings.sales_db} .customer_invoice ci 
                        
            //              left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = ci.unit_id 
            //              where exporter_id = '${invoiceDto.exporterId}' and year(ci.created_at) = ${createdYear} and month(ci.created_at) >= 4 `;
            // } else {
            //     query = `SELECT MAX(ref_no) as refNumber FROM ${appSettings.sales_db} .customer_invoice ci 
                        
            //              left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = ci.unit_id 
            //              where exporter_id = '${invoiceDto.exporterId}' and year(ci.created_at) = ${createdYear} and month(ci.created_at) < 4`;
            // }
            const queryManager = getManager();
            const refinfo = await queryManager.query(query);
            refNum = refinfo[0]?.refNumber
            ? Number(refinfo[0].refNumber) + 1
            : 1;
    
            

            // else if(plant.data?.company === CompanyTypeEnum.BMR_EXPORTS_AP){

            //     company ="E"
            // }
    
           
            const invNum =
  `${companyPrefix}-${refNum.toString().padStart(3, '0')}/${financialYear}`;

    console.log(invNum,"invoice num 9346")
            count = await this.csInvoiceRepo.count();
            count = count + 1;
            if (!isUpdate) {
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear-1);
                    toDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }
                const customerInvEntity = await this.getDuplicateInvoice(invoiceDto.saleOrderId);
                if (customerInvEntity) {
                    return new PlantInvoiceCreateResponse(false, 11104, 'Already Invoiced');
                }
            }

    
            const currentFinancialYear = "INV/" + (fromDate) + "-" + (toDate) + "/" + count;
            console.log(invoiceDto);
            console.log('Service');
            // convert entity to dto
            const convertedEntity = await this.adapter.convertDtoToEntity(invoiceDto, invNum,refNum,financialYear);
            console.log(convertedEntity,">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            await manager.startTransaction();
    
            // save the converted Entity
            const savedEntity = await manager.getCustomRepository(CustomerInvoiceRepository).save(convertedEntity);
            console.log("----------------------------------------------------------")
            if (savedEntity) {
                for (const invoiceItems of invoiceDto.invoiceItemsInfo) {
                    const csInvItem = new SaleOrderItems();
                    csInvItem.saleOrderItemId = invoiceItems.saleOrderItemId;
                    csInvItem.revisedUnitPrice = invoiceItems.revisedUnitPrice;
                    csInvItem.invoicedQty = invoiceItems.invoicedQuantity;
                    csInvItem.invoicedCases = invoiceItems.invoicedCases;
                    csInvItem.invoiceAmount = invoiceItems.invoiceAmount;
                    csInvItem.grossWeightPerKg = invoiceItems.grossWeight;
                    csInvItem.frozenWeight = invoiceItems.frozenWeight;
                    //for temperory dispatched qty given.need to remove after completion of warehouse as dispatched qty updated from warehouse
                    //csInvItem.dispatchedQty = invoiceItems.dispatchedQty;
                    csInvItem.totalGrossWeight = invoiceItems.grossWeight * invoiceItems.invoicedCases;
                    console.log('*******revisedUnitPrice ', csInvItem.revisedUnitPrice);
                    csInvItem.taxId = invoiceItems.taxId;
                    const updateInvItem = await manager.getCustomRepository(SoItemRepository).save(csInvItem);
                }
                const updateSo = await manager.getCustomRepository(SoRepository).update({ saleOrderId: invoiceDto.saleOrderId }, {
                    isInvoiced: GlobalStatus.YES
                });
                const updateInvDetails = await manager.getCustomRepository(SoInvoiceRepository).update({ saleOrderId: invoiceDto.saleOrderId }, {
                    payTermId: invoiceDto.paymentTerms, destination: invoiceDto.finalDestination, portOfEntry: invoiceDto.portOfLoading, edaDate: invoiceDto.etaDate
                });
    
                if (updateSo.affected && updateInvDetails.affected && !isUpdate) {
                    await manager.completeTransaction();
                } else {
                    if (isUpdate) {
                        await manager.completeTransaction();
                    } else {
                        throw new ErrorResponse(9999, 'Failed To Update Sale Order');
                    }
                }
                return new PlantInvoiceCreateResponse(true, 1111, 'Invoice Created Successfully');
            } else {
                throw new ErrorResponse(9999, 'Something Went Wrong');
            }
    
        } catch (err) {
            await manager.releaseTransaction();
            console.log(err);
            return err;
        }
    }
    

    async getDuplicateInvoice(saleOrderId: number): Promise<SoCustomerInvoice> {
        //  console.log(employeeId);
            const response = await this.csInvoiceRepo.findOne({
            where: {saleOrderId: saleOrderId,isActive:true},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }
        async getInvoiceNumberData(): Promise<CommonResponse> {

            try {
                const manager = getManager();
                let query = `select * from customer_invoice ci where ci.is_active =1`;
                const details = await manager.query(query);
                if (details.length > 0) {
                    return new CommonResponse(true, 1000, 'Data Retrieved', details);
                } else {
                    return new CommonResponse(false, 1001, 'No Data Found', details);
                }
            } catch (err) {
                throw err;
            }
    
            
        }

        async updatePath(filePath: string,filename:string,invoiceId: number): Promise<FileUploadResponse> {
            console.log(filePath,'ffffffffff')
            console.log(filename,'nnnnnnnnnnnnnnnnnn')
            console.log(invoiceId,'iddddddddddddddddd')
            try{
                const filePathUpdate = await this.csInvoiceRepo.update(
                    { invoiceId: invoiceId },
                    { filePath: filePath ,fileName:filename},
                   
                  );
                  if (filePathUpdate.affected > 0) {
                    return new FileUploadResponse( true, 11, 'uploaded successfully',filePath);
                  }
                  else{
                    return new FileUploadResponse( false, 11, 'uploaded failed',filePath);
                  }
            }
            catch(error){   
                console.log(error); 
            }
          }

async cancelInvoice(req: any): Promise<CommonResponse> {
    const queryRunner = this.connection.createQueryRunner();
    await queryRunner.connect();
    await queryRunner.startTransaction();

    try {
      const invoiceNumber = req?.invoiceNumber;
      if (!invoiceNumber) {
        return new CommonResponse(false, 400, "Invoice number is required");
      }

      const invoice = await queryRunner.manager.findOne(SoCustomerInvoice, {
        where: { invoiceNumber },
      });

      if (!invoice) {
        return new CommonResponse(false, 404, "Invoice not found");
      }

    const soTrack = await queryRunner.manager.findOne(SaleOrderTrack, {
  where: {
    saleOrderInfo: { saleOrderId: invoice.saleOrderId },
  },
  relations: ["saleOrderInfo"],
});

if (soTrack && soTrack.containerStatus === ContainerStatusEnum.SHIPPED) {
  return new CommonResponse(
    false,
    400,
    "Cannot cancel invoice. The Sale Order has already been shipped."
  );
}

      invoice.isActive = false;
      await queryRunner.manager.save(SoCustomerInvoice, invoice);

      const soEntity = await queryRunner.manager.findOne(SaleOrder, {
        where: { saleOrderId: invoice.saleOrderId },
      });

      if (!soEntity) {
        throw new Error("Sale Order not found for this invoice");
      }

      soEntity.isInvoiced = "NO";
      await queryRunner.manager.save(SaleOrder, soEntity);

      await queryRunner.manager.update(
        SaleOrderItems,
        { saleOrderId: invoice.saleOrderId },
        {
          invoicedCases: 0,
          invoicedQty: 0,
          invoiceAmount: 0,
          grossWeightPerKg:0,
          revisedUnitPrice:0
        },
      );

const soTrackEntity = await queryRunner.manager.findOne(SaleOrderTrack, {
  where: { saleOrderInfo: { saleOrderId: invoice.saleOrderId } },
  relations: ["saleOrderInfo"],
});

if (soTrackEntity) {
  soTrackEntity.invoiceStatus = InvoiceStatusEnum.CANCEL;
  await queryRunner.manager.save(SaleOrderTrack, soTrackEntity);
}

      await queryRunner.commitTransaction();
      return new CommonResponse(true, 200, "Invoice cancelled successfully");
    } catch (error) {
      await queryRunner.rollbackTransaction();
      return new CommonResponse(false, 500, "Error cancelling invoice", error.message);
    } finally {
      await queryRunner.release();
    }
  }

}
